import { Component } from '@angular/core';

import AppGuidelinesModule from '../../app-guidelines.module';

@Component({
    selector: 'property-card-expanded',
    imports: [AppGuidelinesModule],
    templateUrl: './property-card-expanded.component.html',
    styleUrls: ['../property-card.component.less', './property-card-expanded.component.less'],
})
class PropertyCardExpandedComponent {}

export default PropertyCardExpandedComponent;
